module.exports = __webpack_public_path__ + "static/media/provider-01.d1876d3d.png";